export default "__VITE_ASSET__Bbsbd$fp__"